import { useSelector } from 'react-redux';
import l from '../../../../lang';
import { Button } from '../../../common/button';
import { Urls } from '../../../../config/urls';
import { openNewTabAndFocus } from '../../../../utils';
import {
  segmentIntegrationsApiIntegrationPageLinkDocs,
  segmentIntegrationStarted,
} from '../../../../utils/analytics';
import { DashboardSelectors } from '../../../../store/dashboard/selectors';
import apiSectionHeader from '../../../../assets/images/api-section-header.svg?url';
import SettingIcon from '../../../../assets/icons/api-hero/setting.svg?url';
import TrendIcon from '../../../../assets/icons/api-hero/trend.svg?url';
import SlidersIcon from '../../../../assets/icons/api-hero/sliders.svg?url';

const HERO_TAGS = [
  { key: 'paymentIntegration.api.page.hero.tag.automation', icon: SettingIcon },
  { key: 'paymentIntegration.api.page.hero.tag.scalability', icon: TrendIcon },
  { key: 'paymentIntegration.api.page.hero.tag.dataControl', icon: SlidersIcon },
] as const;

const ApiHero = () => {
  const userMe = useSelector(DashboardSelectors.getUserMe);

  return (
    <div className="api_hero">
      <div className="api_hero__content">
        <h2 className="api_hero__headline">{l('paymentIntegration.api.page.hero.headline')}</h2>
        <p className="api_hero__description">{l('paymentIntegration.api.page.hero.description')}</p>
        <div className="api_hero__tags">
          {HERO_TAGS.map(tag => (
            <span key={tag.key} className="api_hero__tag">
              <img src={tag.icon} alt="" aria-hidden />
              {l(tag.key)}
            </span>
          ))}
        </div>
        <div className="api_hero__actions">
          <Button
            textTransformNone
            variant="contained"
            className="api_hero__cta api_hero__cta--primary"
            onClick={() => {
              segmentIntegrationStarted(userMe?.id ?? 0);
              openNewTabAndFocus(Urls.docs.apiSandboxDashboard);
            }}
          >
            {l('paymentIntegration.api.page.hero.cta.sandbox')}
          </Button>
          <Button
            textTransformNone
            variant="outlined"
            className="api_hero__cta api_hero__cta--secondary"
            onClick={() => {
              segmentIntegrationStarted(userMe?.id ?? 0);
              segmentIntegrationsApiIntegrationPageLinkDocs();
              openNewTabAndFocus(Urls.docs.apiIntegration);
            }}
          >
            {l('paymentIntegration.api.page.hero.cta.docs')}
          </Button>
        </div>
      </div>
      <div className="api_hero__illustration">
        <img src={apiSectionHeader} alt="" />
      </div>
    </div>
  );
};

export default ApiHero;
